import Navbar from '@/components/Navbar';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Card>
          <CardHeader>
            <CardTitle className="text-3xl">About OliSeq</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="prose max-w-none">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">Our Company</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                OliSeq is a leading provider of custom primer and probe design services for molecular biology research. 
                We specialize in qPCR, RT-PCR, and digital PCR assay design and optimization.
              </p>

              <h2 className="text-xl font-semibold text-gray-900 mb-4 mt-6">Our Services</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                We offer comprehensive solutions for:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                <li>Custom primer and probe design</li>
                <li>Real-Time PCR assay development</li>
                <li>Digital PCR assay optimization</li>
                <li>Gene expression analysis</li>
                <li>Genotyping and SNP detection</li>
                <li>Pathogen detection assays</li>
              </ul>

              <h2 className="text-xl font-semibold text-gray-900 mb-4 mt-6">Quality & Expertise</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Our team of experienced scientists uses advanced bioinformatics tools and proprietary algorithms 
                to ensure the highest quality primer and probe designs for your research needs.
              </p>

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mt-8">
                <p className="text-gray-700 text-center">
                  <strong>Note:</strong> This is a placeholder page. More detailed content will be added soon.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default About;
